import './FeedCardNew.css';
import { useState } from 'react';
import { FaRegHeart, FaRegCommentDots, FaShareAlt } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa6";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { TiArrowLeft } from "react-icons/ti";
import { TiArrowRight } from "react-icons/ti";
import { API_BASE_URL } from '../../utils';
import { Link } from 'react-router-dom';
import axios from 'axios';


const url = `${API_BASE_URL}/master/assets/uploads/`;


export default function FeedCardNew({ data }) {

    console.log(data);

    const userData = JSON.parse(localStorage.getItem("userData"));

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % data?.images?.length);
    const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + data?.images?.length) % data?.images?.length);


    function generateClubUrl(clubName, cityName, areaName) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }

    const handleAddRemoveFav = async (e, eventData) => {
        e?.preventDefault();

        const formdata = new FormData();
        formdata.append("club_id", eventData.id);
        formdata.append("user_id", userData.id);

        try {
            const response = await axios.post(`${API_BASE_URL}/master/APIs/Common/addToFav`, formdata);

            if (response.status === 200) {
                const { is_fav } = response.data; // assuming backend returns this
                if (is_fav) {
                    console.log("Added to favorites");
                } else {
                    console.log("Removed from favorites");
                }
            } else {
                console.warn("Unexpected response status:", response.status);
            }
        } catch (error) {
            console.error("Failed to add/remove favorite:", error);
        }
    };

    return (
        <div className="feed-card">
            {/* Header */}

            <div className='feed-card-image-content-section-wrapper'>

                <div className="feed-card-header">
                    <div>
                        <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName)} style={{ textDecoration: "none", color: "inherit" }}>
                            <img
                                className="feed-card-avatar"
                                src={url + (data.clubLogo)}
                                alt="Club"
                            />
                        </Link>
                    </div>
                    <div className="feed-card-header-details">

                        <h4> <Link to={`/${data?.meta?.slug}`} style={{ textDecoration: "none", color: "inherit" }}>
                            {data?.clubName}
                        </Link> <span className="verified-badge"><RiVerifiedBadgeFill />
                            </span></h4>
                        <p>  {data?.meta?.address
                            ? data.meta.address.length > 30
                                ? data.meta.address.slice(0, 30) + "..."
                                : data.meta.address
                            : "--"}

                            {/* {distance > 0 ? `${distance}Kms` : ""} */}
                            {" "}</p>
                    </div>
                </div>

                <div>
                    <div className='feed-card-image-content-section'>

                        {/* Banner Carousel */}
                        <div className="feed-card-carousel">
                            <div className='feed-event-image'>

                                <div className="image-wrapper">
                                    <div className="feed-card-carousel">
                                        <div className="carousel-label">Add On up to 50% Extra on Food & Beverages</div>
                                        {data?.images?.length > 0 && (
                                        <div className="carousel-image" style={{ backgroundImage: `url(${url + data?.images[currentIndex]?.img})` }}>
                                            <span className="carousel-tag">{data?.category}</span>
                                            <button className="carousel-arrow left" onClick={prevSlide}><TiArrowLeft /></button>
                                            <button className="carousel-arrow right" onClick={nextSlide}><TiArrowRight /></button>
                                        </div>
                                        )}
                                        <Link to={'/package-lead-form'}>
                                            <div className="carousel-actions-section">
                                                <div className="feed-book-now">Book Now</div>
                                                <i class="fi fi-br-angle-right"></i>
                                            </div>
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* Footer Actions */}
                        <div className="feed-card-actions-event">
                            <div className="feed-card-icons-section" style={{ pointerEvents: 'none' }}>
                                <div className='feed-card-icon-box' onClick={(e) => handleAddRemoveFav(e, { id: data.club_id })}>
                                    <i class="fi fi-tr-circle-star feed-icons-new-card"></i>
                                </div>
                            </div>
                            <div className="feed-card-icons-section" style={{ pointerEvents: 'none' }}>
                              
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

